import React from "react";
import styles from "./Button.module.scss";

/**
 * Tek Button component'i — Btn + reactstrap.Button + raw <button>'u
 * birleştirir. AbstractElements.jsx'teki Btn için drop-in replacement
 * niyetiyle yazıldı (Faz 11'de eski Btn import'u buna alias edilebilir).
 *
 * <Button variant="primary" size="md" onClick={...}>Kaydet</Button>
 *
 * variant: "primary" | "secondary" | "ghost" | "danger" | "link"
 * size:    "sm" | "md" | "lg"
 */
const VARIANT_BG = {
  primary: "var(--ds-brand)",
  secondary: "var(--ds-surface)",
  ghost: "transparent",
  danger: "var(--ds-danger)",
  link: "transparent",
};

const VARIANT_FG = {
  primary: "var(--ds-brand-fg)",
  secondary: "var(--ds-text)",
  ghost: "var(--ds-text)",
  danger: "#fff",
  link: "var(--ds-info)",
};

const VARIANT_BORDER = {
  primary: "1px solid var(--ds-brand)",
  secondary: "1px solid var(--ds-border)",
  ghost: "1px solid transparent",
  danger: "1px solid var(--ds-danger)",
  link: "1px solid transparent",
};

const SIZE_PADDING = {
  sm: "var(--sp-1) var(--sp-3)",
  md: "var(--sp-2) var(--sp-4)",
  lg: "var(--sp-3) var(--sp-5)",
};

const SIZE_FONT = {
  sm: "0.8125rem",
  md: "0.9375rem",
  lg: "1rem",
};

const SIZE_HEIGHT = {
  sm: 32,
  md: 40,
  lg: 48,
};

const Button = React.forwardRef(
  (
    {
      type = "button",
      variant = "primary",
      size = "md",
      disabled,
      loading,
      iconLeft,
      iconRight,
      block,
      className,
      style,
      children,
      ...rest
    },
    ref
  ) => (
    <button
      ref={ref}
      type={type}
      disabled={disabled || loading}
      className={[styles.button, className].filter(Boolean).join(" ")}
      style={{
        "--btn-bg": VARIANT_BG[variant],
        "--btn-fg": VARIANT_FG[variant],
        "--btn-border": VARIANT_BORDER[variant],
        "--btn-padding": SIZE_PADDING[size],
        "--btn-font-size": SIZE_FONT[size],
        "--btn-height": `${SIZE_HEIGHT[size]}px`,
        "--btn-width": block ? "100%" : undefined,
        "--btn-cursor": disabled || loading ? "not-allowed" : "pointer",
        "--btn-opacity": disabled || loading ? 0.6 : 1,
        ...style,
      }}
      {...rest}
    >
      {iconLeft}
      {loading ? "…" : children}
      {iconRight}
    </button>
  )
);
Button.displayName = "Button";

export default Button;
